import { render, staticRenderFns } from "./EcommerceMargin.vue?vue&type=template&id=8cf67450&"
import script from "./EcommerceMargin.vue?vue&type=script&lang=js&"
export * from "./EcommerceMargin.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceMargin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports